const useGetBackgroundColor = id => {
  let color;
  const lastDigit = id.toString().slice(-1);
  switch (lastDigit) {
    case '1':
    case '2':
      color = 'bg-yellow-400';
      break;
    case '3':
    case '4':
      color = 'bg-blue-400';
      break;
    case '5':
    case '6':
      color = 'bg-purple-400';
      break;
    case '7':
    case '8':
    case '9':
      color = 'bg-green-400';
      break;
    default:
      color = 'bg-red-400';
      break;
  }
  return color;
};

export default useGetBackgroundColor;
